var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAfsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.355 2.869-.227 8.717L18.2 6.81l5.154-3.94Z",
    fill: "#5170FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.143 23.667-6.532 2.99 3.856-12.896 2.676 9.906Z",
    fill: "#CB9D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.094 18.728 9.444-6.185-8.925-8.654-2.372 7.981 1.853 6.858Z",
    fill: "#EC6224"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.203 1.342 12.568 3.45l-2.254 7.582-9.11-9.689Z",
    fill: "#55AC55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m28.167 4.594-3.978 2.13.084-3.855 3.894 1.725Z",
    fill: "#7338AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAfsImage);
export default __webpack_public_path__ + "static/media/logo-afs-image.c409836e.svg";
export { ForwardRef as ReactComponent };